interface Props {
  className?: string;
}

export default function BalloonIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 18 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.6667 25L5 21H9H13C12.7667 21.1889 11.3 25 11.3 25L6.6667 25Z"
        fill="currentColor"
      />
      <path
        d="M1 9C1 13.571 6.714 17 6.714 17H11.286C11.286 17 17 13.571 17 9C17 4.429 13.418 1 9 1C4.582 1 1 4.429 1 9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99998 1.5C2.99998 7.5 6.99998 17 6.99998 17M11.884 1.5C14.884 7.5 10.884 17 10.884 17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <line
        x1="5.47434"
        y1="15.8419"
        x2="7.47434"
        y2="21.8419"
        stroke="currentColor"
      />
      <line
        x1="12.4743"
        y1="16.1581"
        x2="10.4743"
        y2="22.1581"
        stroke="currentColor"
      />
    </svg>
  );
}
